<template>
    <div class="mx-auto px-6 py-12 xl:max-w-[1528px]">
        <div class="mb-[42px]">
            <h1 class="text-3xl font-medium text-gray-900">
                {{ $t("vue.changelog") }}
            </h1>
        </div>

        <div class="space-y-8">
            <div
                v-for="e in entries"
                :key="e.version + e.release_date"
                class="grid grid-cols-12 gap-8"
            >
                <div class="col-span-12 lg:col-span-3">
                    <div class="text-gray-800">
                        <div class="text-sm font-semibold text-gray-700">
                            {{ e.version }}
                        </div>
                        <div class="mt-1 text-xs text-gray-500">
                            Release date: {{ e.release_date }}
                        </div>
                    </div>
                </div>

                <div class="col-span-12 lg:col-span-9">
                    <div
                        class="mx-auto w-full rounded-md bg-white shadow-card lg:mx-0"
                    >
                        <div class="p-6">
                            <div class="space-y-6">
                                <div
                                    v-for="(b, idx) in e.blocks"
                                    :key="e.version + '-b-' + idx"
                                >
                                    <div
                                        class="text-sm font-semibold text-gray-900"
                                    >
                                        {{ b.title }}
                                    </div>

                                    <ul
                                        v-if="b.items?.length"
                                        class="mt-2 list-disc pl-5 text-sm text-gray-700 space-y-1"
                                    >
                                        <li v-for="(it, i) in b.items" :key="i">
                                            {{ it }}
                                        </li>
                                    </ul>

                                    <div
                                        v-else
                                        class="mt-1 text-xs text-gray-500"
                                    >
                                        {{ b.description }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="!entries?.length"
                class="rounded-md bg-white shadow-card p-6"
            >
                <div class="text-sm font-medium text-gray-900">
                    {{ $t("vue.no_changelog_entries") }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useTranslations } from "@/composables/useTranslations.ts";

const { t } = useTranslations();

type ChangelogBlock =
    | { title: string; items: string[]; description?: never }
    | { title: string; description: string; items?: never };

type ChangelogEntry = {
    version: string;
    release_date: string;
    blocks: ChangelogBlock[];
};

defineProps<{
    entries: ChangelogEntry[];
}>();
</script>
